<template>
  <div id="page">
    <div align="center" style="margin-top: 48px;">
      <div>
        <img src="../../static/invoice.png" width="96px" height="72px" />
      </div>
      <div style="margin-top: 16px;">
        <h3>开具发票说明</h3>
      </div>
    </div>

    <div style="padding: 8px; text-align: left;">
      <div style="padding: 16px;">
        <label>订单号:</label>
        <div style="margin-top: 4px;">
          <b><label>{{orderNo}}</label></b>
        </div>
      </div>

      <ol>
        <li style="padding: 4px;">尊敬的客户，如您需要开具发票，请您在支付成功后，通过邮件方式提出开票申请，没有提交申请视为放弃开票需求。</li>
        <li style="padding: 4px;">您的电子普通发票将由恒宝股份有限公司开具。</li>
        <li style="padding: 4px;">因为您的版面定制储蓄卡是以个人名义申请，电子发票只能以您的姓名或“个人”名义开具，请将您的姓名和订单编号一起发送到开票邮箱invoice.hbdiy@hengbao.com。</li>
        <li style="padding: 4px;">我们将在照片审核通过后10个工作日为您开具电子普通发票，收件人邮箱是您提交申请的邮箱地址，请注意查收。</li>
      </ol>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Invoice',
    data() {
      return {
        orderNo: ''
      }
    },
    mounted: function() {
      this.orderNo = this.$route.params.orderNo;
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Invoice.vue